import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

export type ConfigurationKey = {
  key: string;
  value: string;
  comment?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export const useGetConfigurationKey = (
  key?: string,
): {
  config: ConfigurationKey;
  loading: boolean;
  error: any;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useQuery(
    gql`
      query ($key: String!) {
        getConfig(key: $key) {
          key
          value
          comment
        }
      }
    `,
    {
      fetchPolicy: 'network-only',
      variables: {
        key,
      },
      skip: key === null || key === undefined || key === '',
    },
  );

  return {
    config: data?.getConfig,
    loading,
    error,
    refetch,
  };
};
